/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {FolderShareProps} from '../FolderShared';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Dashboard Share Icon component.
 */
const DashboardShare = ({folderColor}: FolderShareProps) => {
  const {iconColor} = useIconDLS({color: folderColor});

  return (
    <svg key={folderColor} width='16' height='20' viewBox='0 0 16 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M4.25 4.35H11.25M4.25 7.95H11.25M4.25 11.55H6.875M2.5 18.75H13C13.9665 18.75 14.75 17.9441 14.75 16.95V2.55C14.75 1.55589 13.9665 0.75 13 0.75H2.5C1.5335 0.75 0.75 1.55589 0.75 2.55V16.95C0.75 17.9441 1.5335 18.75 2.5 18.75Z' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  );
};

export default React.memo(DashboardShare);
